import mitt from 'mitt';

export default class Sound {
  constructor(src) {
    Object.assign(this, mitt());

    this._src = src;
    this._ended = true;

    this.audio = new Audio(src);

    this.audio.addEventListener('playing', () => {
      this.emit('play');
      this._ended = false;
    });

    this.audio.addEventListener('ended', () => {
      this.emit('ended');
      this._ended = true;
    });
  }

  play() {
    this.audio.play();
  }

  stop(doNotEmit) {
    this.seek(0);
    this.pause();

    if (!doNotEmit) this.emit('stopped');
    this._ended = true;
  }

  pause() {
    this.audio.pause();
  }

  mute(shouldMute) {
    if (shouldMute) {
      this.audio.muted = true;
    } else {
      this.audio.muted = false;
    }
  }

  seek(seconds) {
    const duration = this.audio.duration;
    if (seconds != null) {
      this.audio.currentTime = seconds;
      return { duration, position: seconds };
    } else {
      return { duration, position: this.audio.currentTime };
    }
  }

  restart() {
    this.seek(0);
    this.play();
  }

  get isPaused() {
    return this.audio.paused;
  }

  get isPlaying() {
    return !this.isPaused;
  }

  get isDone() {
    return this._ended;
  }

  get percentComplete() {
    const { duration, position } = this.seek();
    return position / duration * 100;
  }
}



// WEBPACK FOOTER //
// ./components/sound.js